import graphql from "babel-plugin-relay/macro";
import styled from "styled-components";
import IconButton from "./Buttons/IconButton";
import { useFragment } from "react-relay";
import {
  InspectionReportCard$key,
  InspectionStateEnum,
} from "./__generated__/InspectionReportCard.graphql";
import { StateColors } from "../pages/InspectionList/StateHelpers";

const CompletedStateTitles: {
  [key in InspectionStateEnum]?: string;
} = {
  APPROVED: "Akkoord",
  REJECTED: "Niet akkoord",
  RETRY: "Herstel",
};

const InspectionReportCard = ({
  inspection,
}: {
  inspection: InspectionReportCard$key;
}) => {
  const data = useFragment(
    graphql`
      fragment InspectionReportCard on InspectionNode {
        id
        inspector {
          firstName
          lastName
          user {
            firstName
            lastName
          }
        }
        inspectionfield {
          collective {
            name
          }
          year
          managementPackageSetting {
            displayNameAlt
          }
        }
        report {
          id
          pdf {
            downloadUrl
          }
        }
        state
        approvedDate
        rejectedDate
        retryDate
        retry
        pdfName
      }
    `,
    inspection
  );
  const inspector = data?.inspector;
  const inspectorName = `${
    inspector?.user?.firstName || inspector?.firstName
  } ${inspector?.user?.lastName || inspector?.lastName}`;
  const inspectionDate =
    data?.approvedDate ||
    data?.rejectedDate ||
    (!data.retry ? data?.retryDate : undefined);

  return (
    <>
      <Container key={data?.id}>
        <InfoBlock>
          <Header>
            <h3>
              {`${data?.inspectionfield?.managementPackageSetting?.displayNameAlt}`}
            </h3>
            <State borderColor={StateColors[data?.state || "RETRY"] || "black"}>
              {CompletedStateTitles[data?.state || "RETRY"]}
            </State>
          </Header>
          <Details>
            <p>{data?.inspectionfield?.year}</p>
            <p>■</p>
            <p>Uitgevoerd op {new Date(inspectionDate).toLocaleDateString()}</p>
            <p>■</p>
            <p>Door {inspectorName}</p>
          </Details>
        </InfoBlock>
        {data?.report?.pdf?.downloadUrl ? (
          <IconButton
            icon={"download"}
            size="large"
            iconColor="white"
            backgroundColor="#0075BC"
            borderColor="#0075BC"
            tooltip="Download rapport"
            onClick={() =>
              window.open(data?.report?.pdf?.downloadUrl || "", "_blank")
            }
          />
        ) : null}
      </Container>
    </>
  );
};

export default InspectionReportCard;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  height: 77px;
  border-radius: 5px;
  box-shadow: 0 10px 15px 0px rgba(168, 168, 168, 0.2);
  padding: 12px;
  background-color: white;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  span {
    color: var(--donkergrijs, #212529);
    /* Tablet/Label bold */
    font-family: Roboto;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
`;

const State = styled.div<{ borderColor: string }>`
  border: 2px solid;
  border-radius: 100px;
  border-color: ${(props) => props.borderColor};
  padding: 6px;
  margin-left: 12px;
  min-width: 85px;
  color: var(--donkergrijs, #212529);
  text-align: center;
  /* Label bold */
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;

const Details = styled.div`
  display: flex;
  p {
    color: var(--donkergrijs, #212529);
    /* Label regular */
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    padding-right: 8px;
  }
`;
